import { render, staticRenderFns } from "./ConfigQuestionText.vue?vue&type=template&id=4fed6c60&scoped=true&"
import script from "./ConfigQuestionText.vue?vue&type=script&lang=js&"
export * from "./ConfigQuestionText.vue?vue&type=script&lang=js&"
import style0 from "./ConfigQuestionText.vue?vue&type=style&index=0&id=4fed6c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed6c60",
  null
  
)

export default component.exports